// extracted by mini-css-extract-plugin
module.exports = {"tab__header":"Administration_tab__header__2Qlya","tab__item":"Administration_tab__item__1ndg1","list":"Administration_list__160U2"};